import {createSelector} from 'reselect';
import DisabledCheckoutPageCalls from '../../../../enums/DisabledCheckoutPageCalls';
import {getDisabledCheckoutPageCalls} from '../../getDisabledCheckoutPageCalls';
import {getPaymentOptions} from '../PaymentOptionSelectors';

export default createSelector(
  [getPaymentOptions, getDisabledCheckoutPageCalls],
  (availablePaymentOptions, disabledCheckoutPageCalls) => availablePaymentOptions
    .some(paymentOption => paymentOption.name === 'ALIPAY_PLUS')
    && !disabledCheckoutPageCalls.includes(DisabledCheckoutPageCalls.ALIPAY_PLUS_SESSION),
);
